<template>
  <footer class="app-footer">
  	<div style="text-align: center;">© {{currentyear}} XpressBees.</div>
  </footer>
</template>
<script>
export default {
  name: 'footer',
    data() {
    return {
      currentyear: (new Date()).getFullYear()
    };
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue?06b4ed8c